import { Link } from "react-router-dom";

import { ACCESS_LEVELS, PERMISSION_AREAS } from "api/common/types/auth.types";
import { useAuth } from "hooks/useAuth";
import { checkPermissions } from "utils/permissions";

const EcrIdCell = ({ ecrid }: { ecrid: string | number }) => {
  const { permissions } = useAuth();

  const canAccessEcrs = checkPermissions({
    permissions,
    area: PERMISSION_AREAS.ECR_COMMENTS,
    access: ACCESS_LEVELS.READ,
  });

  if (canAccessEcrs) {
    return (
      <Link
        to={`/community/ecr-comments/details/${ecrid}`}
        className="text-decoration-underline"
      >
        {ecrid}
      </Link>
    );
  }

  return <>{ecrid}</>;
};

export default EcrIdCell;
